import React from "react";

import { i18n } from "../../../translate/i18n";
import { resolveChannelBadge } from "../../../helpers/channelBadge";

const CHANNEL_LABELS = {
	facebook: () => i18n.t("socialComments.filters.facebook"),
	instagram: () => i18n.t("socialComments.filters.instagram"),
	tiktok: () => i18n.t("socialComments.filters.tiktok"),
	mercadolivre: () => i18n.t("socialComments.filters.mercadolivre"),
};

export function SocialChannelBadge({ channel, className = "" }) {
	const badge = resolveChannelBadge(channel);
	const label = CHANNEL_LABELS[channel]?.() || channel;

	if (badge?.kind === "img") {
		return (
			<span
				className={`inline-flex items-center gap-1.5 rounded-full bg-default-100 px-2 py-0.5 text-[11px] font-medium text-default-700 dark:bg-default-800 dark:text-default-200 ${className}`}
			>
				<img src={badge.src} alt="" className="size-3.5 object-contain" />
				{label}
			</span>
		);
	}

	return (
		<span
			className={`inline-flex rounded-full bg-default-100 px-2 py-0.5 text-[11px] font-medium text-default-700 dark:bg-default-800 dark:text-default-200 ${className}`}
		>
			{label}
		</span>
	);
}

const STATUS_STYLES = {
	open: "bg-primary/10 text-primary",
	replied: "bg-success/10 text-success",
};

export function CommentStatusBadge({ status }) {
	const labelKey = `socialComments.status.${status}`;
	const label = i18n.t(labelKey, { defaultValue: status });
	return (
		<span
			className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${STATUS_STYLES[status] || STATUS_STYLES.open}`}
		>
			{label}
		</span>
	);
}
